import { Component, OnInit,EventEmitter,Output,Input } from '@angular/core';
import { Router } from "@angular/router";

@Component({
  selector: 'dynamic-button',
  template: `
  <button class="btn b-radius box-shadow-b75 text-b100 bg-0 demi-bold h4-m mx-2 pr-3 py-0" (click)="goToLink()" 
  style="border: 1px solid #89BEFF;" *ngIf="iAllowed" [ngStyle]="{'background-image': base64Img}">
   <span class="p-3"> <ng-content></ng-content></span>
</button>`,
  styleUrls: ['./dynamic-button.component.css']
})
export class DynamicButtonComponent implements OnInit {
  @Input() link;
  @Input() isTeacher;
  @Input() isAdmin;
  @Input() isStudent;
  @Input() bgIcon;
  public base64Img:any;

  public iAllowed:boolean=false;

  constructor(private _router:Router) { }

  ngOnInit() {
    this.base64Img="url(data:image/svg+xml;base64,"+ this.bgIcon+")";
    let user=JSON.parse(atob(localStorage.getItem("userData")));
    if((user.userType=='ADMIN' && this.isAdmin) || (user.userType=='TEACHER' && this.isTeacher)) this.iAllowed=true;
    else this.iAllowed=false;
  }

  goToLink(){
    if(this.link)
    this._router.navigateByUrl(this.link);
  }
}   
